import React from "react";

export default function Loading() {
  return <span className="loading__anim"></span>;
}
